import { loginRequestMS as loginRequest, graphConfig } from "../authConfig";
import { msalInstance } from "../msalInstance";

export async function callMsGraph(accessToken) {
    if (!accessToken) {
        // MSAL v5: Nach einem Redirect-Return verarbeitet `MsalProvider` den Auth-
        // Code asynchron. Unser `initialize().then(setActiveAccount)` in index.js
        // läuft zu diesem Zeitpunkt noch mit `getAllAccounts().length === 0`,
        // weshalb `getActiveAccount()` hier `null` zurückgeben kann, obwohl der
        // React-Hook `useMsal()` bereits ein Konto liefert. Fallback: erstes
        // verfügbares Konto übernehmen und für nachfolgende Aufrufe als aktiv
        // markieren.
        let account = msalInstance.getActiveAccount();
        if (!account) {
            const allAccounts = msalInstance.getAllAccounts();
            if (allAccounts.length === 0) {
                throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
            }
            account = allAccounts[0];
            msalInstance.setActiveAccount(account);
        }

        const response = await msalInstance.acquireTokenSilent({
            ...loginRequest,
            account: account
        });
        accessToken = response.accessToken;
    }

    const headers = new Headers();
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);

    const options = {
        method: "GET",
        headers: headers
    };

    return fetch(graphConfig.graphMeEndpoint, options)
        .then(response => response.json())
        .catch(error => console.log(error));
}
